@if (showFab()) {
  <button class="chat-fab" [attr.aria-expanded]="chatOpen()" aria-label="Open Tela Assistant" (click)="toggleChat()">
    <span class="chat-fab-ring" aria-hidden="true"></span>
    <img src="assets/images/logos/SLB/tela.svg" alt="Tela">
  </button>

  @if (chatOpen()) {
    <div class="chat-panel">
      <div class="chat-hd">
        <div class="chat-hd-logo"><img src="assets/images/logos/SLB/tela.svg" alt="Tela" width="28" height="28"></div>
        <span class="chat-hd-title">Tela</span>
        <div class="chat-hd-actions" style="margin-left:auto">
          <button class="chat-hd-btn" aria-label="Close" (click)="closeChat()">
            <app-icon name="close"></app-icon>
          </button>
        </div>
      </div>
      <div class="chat-msgs" style="padding:20px 16px;flex:1;overflow-y:auto;">
        <div class="chat-bot-wrap">
          <div class="chat-bot-text">Hi — I'm <strong>Tela</strong>, your SLB marketplace assistant. Head to the <a routerLink="/catalog" style="color:var(--blue)">Catalog</a> to explore solutions, run comparisons, and get install guidance.</div>
        </div>
      </div>
      <div style="padding:10px 14px 12px;border-top:1px solid var(--g2)">
        <div class="chat-input-pill" style="pointer-events:none;opacity:.5;">
          <app-icon name="search" [size]="16" fill="var(--g4)"></app-icon>
          <span style="font-size:14px;color:var(--g4)">Try full chat in Catalog…</span>
        </div>
      </div>
    </div>
  }
}
